export function IsEmail(email: string): boolean {
    const regexp = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
    return regexp.test(email);
}